import { ArticleHeading4, UIText2 } from '@cian/ui-kit';
import React from 'react';

import * as styles from './ContentItem.css';

type TProps = {
  title: string;
  text?: string;
  comment?: string;
  href: string;
};

export const ContentItem: React.FC<TProps> = ({ title, text, comment, href }) => {
  return (
    <a href={href} className={styles['container']} target="_blank" rel="noopener noreferrer">
      <ArticleHeading4>{title}</ArticleHeading4>
      {text && <UIText2>{text}</UIText2>}
      {comment && (
        <div className={styles['comment']}>
          <UIText2>{comment}</UIText2>
        </div>
      )}
    </a>
  );
};
